<template>
    <div>
        <!-- Botón para agregar comprobante en cada sección de pago -->
        <v-btn color="primary" small class="ml-2" @click="openFileDialog" :disabled="loading">
            <v-icon left>mdi-paperclip</v-icon>
            Agregar documento
        </v-btn>

        <!-- Input oculto para seleccionar archivo -->
        <input type="file" ref="fileInput" accept=".pdf,.jpg,.jpeg,.png" style="display: none"
            @change="handleFileUpload" />

        <!-- Diálogo para previsualizar y confirmar el comprobante -->
        <v-dialog max-width="700">
            <v-card>
                <v-card-title>
                    Documento de identidad
                    <v-spacer></v-spacer>
                    <!-- <span class="subtitle-1">Monto: <input type="number" name="montoPago" id="montoPago">{{
                        formatCurrency(monto) }}</span> -->
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <div v-if="loading" class="text-center">
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                <div class="mt-2">Cargando comprobante...</div>
                            </div>

                            <div v-else-if="previewUrl">
                                <!-- Previsualización de PDF -->
                                <div v-if="isPdf" class="pdf-container">
                                    <iframe :src="previewUrl" width="100%" height="500" frameborder="0"></iframe>
                                </div>

                                <!-- Previsualización de imagen -->
                                <div v-else class="text-center">
                                    <v-img :src="previewUrl" max-height="500" contain></v-img>
                                </div>
                            </div>

                            <div v-else class="text-center pa-5">
                                <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
                                <div class="mt-2 grey--text">Ningún archivo seleccionado</div>
                            </div>
                        </v-col>
                    </v-row>

                    <!-- <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="comentario" label="Comentario (opcional)"
                                placeholder="Agregar comentario sobre este pago" outlined dense></v-text-field>
                        </v-col>
                    </v-row> -->
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="grey darken-1" @click="closeDialog">
                        Cancelar
                    </v-btn>
                    <v-btn color="success" :disabled="!fileSelected || loading" @click="saveComprobante">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Chip que muestra que hay un comprobante adjunto -->
        <div v-if="comprobanteGuardado" class="mt-2">
            
            <span class="caption">{{ nombreArchivo }}</span>
        </div>


        <v-card flat>
            <v-card-title>
                Documento de identidad
                <v-spacer></v-spacer>
            </v-card-title>

            <v-card-text>
                <!-- <v-row>
                    <v-col cols="12">
                        <v-text-field type="number" v-model="monto" label="Monto" required outlined
                            dense></v-text-field>
                    </v-col>
                </v-row> -->

                <!-- <v-row>
                    <v-col cols="12">
                        <v-text-field type="date" v-model="fechaPago" label="Fecha Pago" required outlined
                            dense></v-text-field>
                    </v-col>
                </v-row> -->
                <v-row>
                    <v-col cols="12">
                        <div v-if="loading" class="text-center">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                            <div class="mt-2">Cargando comprobante...</div>
                        </div>

                        <div v-else-if="previewUrl">
                            <!-- Previsualización de PDF -->
                            <div v-if="isPdf" class="pdf-container">
                                <iframe :src="previewUrl" width="100%" height="500" frameborder="0"></iframe>
                            </div>

                            <!-- Previsualización de imagen -->
                            <div v-else class="text-center">
                                <v-img :src="previewUrl" max-height="500" contain></v-img>
                            </div>
                        </div>

                        <div v-else class="text-center pa-5">
                            <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
                            <div class="mt-2 grey--text">Ningún archivo seleccionado</div>
                        </div>
                    </v-col>
                </v-row>

                <!-- <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="comentario" label="Comentario (opcional)"
                            placeholder="Agregar comentario sobre este pago" outlined dense></v-text-field>
                    </v-col>
                </v-row> -->
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="grey darken-1" @click="closeDialog">
                    Cancelar
                </v-btn>
                <v-btn color="success" :disabled="!fileSelected || loading" @click="saveComprobante">
                    Confirmar
                </v-btn>
            </v-card-actions>
        </v-card>


        <!-- Snackbar para mensajes -->
        <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor">
            {{ snackbarText }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    props: {
        // monto: {
        //     type: [Number, String],
        //     required: false,
        //     default: 0
        // },
        seccion: {
            type: String,
            required: false
        },
        numeroCuota: {
            type: [Number, String],
            default: null
        }
    },

    data() {
        return {
            fechaPago: '',
            monto: 0,

            menu1: false,
            dialog: false,
            loading: false,
            fileSelected: false,
            selectedFile: null,
            previewUrl: null,
            isPdf: false,
            comentario: '',
            comprobanteGuardado: false,
            nombreArchivo: '',

            // Para mensajes
            snackbar: false,
            snackbarText: '',
            snackbarColor: 'success'
        }
    },

    methods: {
        openFileDialog() {
            this.$refs.fileInput.click();
        },

        handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.loading = true;
            this.selectedFile = file;
            this.nombreArchivo = file.name;
            this.fileSelected = true;

            // Determinar si es PDF
            this.isPdf = file.type === 'application/pdf';

            // Crear URL para previsualización
            const reader = new FileReader();
            reader.onload = (e) => {
                this.previewUrl = e.target.result;
                this.loading = false;
                this.dialog = true;
            };

            reader.onerror = () => {
                this.loading = false;
                this.showMessage('Error al cargar el archivo', 'error');
            };

            reader.readAsDataURL(file);
        },

        closeDialog() {
            this.dialog = false;

            // Si no había guardado comprobante anteriormente, limpiar la selección
            if (!this.comprobanteGuardado) {
                this.resetFile();
            }
        },

        resetFile() {
            this.fileSelected = false;
            this.selectedFile = null;
            this.previewUrl = null;
            this.comentario = '';
            this.$refs.fileInput.value = '';
        },

        saveComprobante() {
            this.loading = true;

            // Aquí se implementaría la lógica para guardar el archivo en el servidor
            // Por ejemplo, usando axios para enviar el archivo a una API

            // Simulamos una operación de guardado
            setTimeout(() => {
                this.comprobanteGuardado = true;
                this.loading = false;
                this.dialog = false;

                // Emitir evento para notificar al componente padre
                this.$emit('comprobante-guardado', {
                    
                    monto: this.monto,
                    fechaPago: this.fechaPago,                    
                    archivo: this.selectedFile,
                    comentario: this.comentario
                });

                this.showMessage('Docuemnto cargado correctamente', 'success');
            }, 1000);
        },

        openPreview() {
            if (this.comprobanteGuardado) {
                this.dialog = true;
            }
        },

        showMessage(text, color = 'success') {
            this.snackbarText = text;
            this.snackbarColor = color;
            this.snackbar = true;
        },

        formatCurrency(value) {
            // Formatea el monto como moneda
            const num = parseFloat(value);
            if (isNaN(num)) return value;

            return num.toLocaleString('es-BO', {
                style: 'currency',
                currency: 'BOB'
            });
        }
    }
}
</script>

<style scoped>
.pdf-container {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
}
</style>